module.exports = __webpack_public_path__ + "img/wap_daren_en2.5559ed48.jpg";